import(/* webpackMode: "eager" */ "/vercel/path0/app/(pages)/blog/[slug]/not-found.js")